import * as React from 'react';
import { hydrateRoot } from 'react-dom/client';
import { UiKitContextProvider } from '@cian/ui-kit/context';

import { TReduxStore } from '../../../shared/types/redux';
import { Application } from '../../../shared/containers/App';
import { IApplicationContext } from '../../../shared/types/ICustomContextParams';

interface IDependencies {
  store: TReduxStore;
  context: IApplicationContext;
}

export function renderApplication(dependencies: IDependencies) {
  const { store, context } = dependencies;
  const { config } = context;
  const {
    page: { deviceType },
  } = store.getState();

  const projectName = config.getStrict<string>('projectName');
  const rootElement = document.getElementById(projectName);

  if (!rootElement) {
    throw new Error(`Unable to find element #${projectName}`);
  }

  hydrateRoot(
    rootElement,
    <UiKitContextProvider deviceType={deviceType} useStaticDeviceType>
      <Application context={context} reduxStore={store} />
    </UiKitContextProvider>,
  );
}
